import React from 'react';
import { TextInput } from '@domain-group/fe-co-form-elements';
import PropTypes from 'prop-types';
import * as styles from './keywords.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Keywords = props => ___EmotionJSX("div", {
  css: styles.filter
}, ___EmotionJSX("div", {
  css: styles.label
}, "Or search by keywords"), ___EmotionJSX(TextInput, {
  placeholder: "eg. waterfront, views, street name",
  onChange: event => props.onChange({
    [props.name]: event.target.value
  }),
  value: props.value || ''
}));
Keywords.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func
};
Keywords.defaultProps = {
  name: 'keywords',
  value: '',
  onChange: () => {}
};
export default Keywords;